@if (headerFormat === 'html') {
  <div class="flex items-center w-full">
    <div class="flex-auto" [innerHTML]="getEncodedHtml() | safehtml"></div>
  </div>
} @else {
  <div>
    <cat-header-label [compact]="compact" [header]="header" [item]="item"></cat-header-label>

    @if (!hideSortInHeader && sort.length > 0 && !compact) {
      <div class="hidden lg:block mat-body-small text-gray-500">
        {{ sortString }}
      </div>
    }
  </div>
}

<div class="hidden lg:flex flex-wrap items-center gap-2">
  @if (item.GulliverRecScore && !compact) {
    <cat-ui-score
      [score]="item.GulliverRecScore"
      class="shrink-0"
    ></cat-ui-score>
  }
  @if (header.license && !compact && header.license.logo) {
    <cat-header-license
      [license]="header.license"
    ></cat-header-license>
  }
  @for (icon of header.icons || []; track icon) {
    @if (icon.type) {
      <span [ngClass]="['text-xs', icon.type || '']" [title]="icon.value"></span>
    }
  }
  @if (!compact) {
    <cat-header-tags [header]="header"></cat-header-tags>
  }
</div>
